import React, { useEffect, useState } from "react";
import Listing from "../Listing";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  getAllPendingListings,
  getAllUsersDetails,
  getListingSubmittedAt,
} from "../utils";

export default function PendingListings() {
  const [listings, setListings] = useState([]);
  const [usersInfo, setUsersInfo] = useState({});

  const getData = async () => {
    try {
      const [pendingListings, allUsers] = await Promise.all([
        getAllPendingListings(),
        getAllUsersDetails(),
      ]);

      const userMap = {};
      if (allUsers) {
        allUsers.forEach((user) => {
          userMap[user.userId] = user;
        });
      }
      setUsersInfo(userMap);
      setListings(pendingListings || []);
    } catch (error) {
      console.error("Error fetching listings:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const transformedData = listings.map((listing) => {
    const owner = usersInfo[listing?.ownerId] || {};
    let avatarUrl = owner.avatar || null;
    if (avatarUrl && !avatarUrl.startsWith("http")) {
      avatarUrl = `${process.env.REACT_APP_BASE_URL}/images/${avatarUrl}`;
    }

    return {
      id: String(listing.id),
      name: listing.listingTitle,
      year: listing.year || "N/A",
      status: listing.boatStatus || "Pending",
      backgroundImage: listing.featured_image,
      boatListed: listing.boatListed,
      boatType: listing.boatType,
      ownerId: listing.ownerId,
      ownerName:
        `${owner.firstName || ""} ${owner.lastName || ""}`.trim() ||
        owner.email ||
        "Unknown",
      ownerAvatar: avatarUrl,
      ownerInitials:
        owner.firstName && owner.lastName
          ? `${owner.firstName[0]}${owner.lastName[0]}`.toUpperCase()
          : "U",
      submittedAt: getListingSubmittedAt(listing, listing.id),
    };
  });

  return (
    <>
      <div class="row">
        <div class="col">
          <div class="page-description">
            <Row>
              <Col xs={6}>
                <h1>Pending Listings</h1>
              </Col>
              <Col
                xs={6}
                className="d-flex justify-content-end align-items-center"
              >
                <Link className="btn btn-primary" to="/dashboard/add-listing">
                  Add Boat
                </Link>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="card calendar-container">
            <div class="card-body">
              {listings.length > 0 ? (
                <Listing
                  data={transformedData}
                  getData={getData}
                  isAdmin
                  showDateColumn
                />
              ) : (
                <p>No listings available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
